import {invalidateCloudBillingEntities} from './store/cloudBillingEntities';
import {invalidateCloudBillingResume} from './store/cloudBillingResume';
import {invalidateCloudBillingSpending} from './store/cloudBillingSpending';
import {invalidateReportsDetailed} from './store/reportsDetailed';

export const invalidateCloudBillingExplorer = () => dispatch => {
    dispatch(invalidateCloudBillingEntities());
    dispatch(invalidateCloudBillingResume());
    dispatch(invalidateCloudBillingSpending());
};

export const invalidateCloudBillingBreakdown = () => dispatch => {
    dispatch(invalidateCloudBillingEntities());
    dispatch(invalidateReportsDetailed());
};




// WEBPACK FOOTER //
// ./src/modules/cloudBilling.js